import { createSlice } from "@reduxjs/toolkit";
import { paySettingReducer } from "../extraReducers/paySettingReducer";

// 定义初始化数据
const initialState = {
  paySettingList: {} as any,
  sensitiveList: {} as any,
  operationRecordList: {} as any,
  getSilverCoinDetailsConfig: {} as any,
  versionConfig: {} as any,
  createVersionConfig: {} as any,
  deleteVersionConfig: {} as any,
  updateVersionConfig: {} as any,
  getWorldChatAdminConfig: {} as any,
  setWorldChatAdminsConfig: {} as any,
  deleteWorldChatAdminsConfig: {} as any
};

const paySettingSlice = createSlice({
  name: "paySetting",
  initialState,
  reducers: {
    resertStore: (state, action) => {
      state.sensitiveList = {};
      state.operationRecordList = {};
    },
  },
  extraReducers: paySettingReducer,
});

export const { resertStore } = paySettingSlice.actions;

// 默认导出,到处的文件需要在store入口文件引入
export default paySettingSlice.reducer;
